export const GET_ENTRY_STRATEGIES = 'GET_ENTRY_STRATEGIES';
export const GET_ENTRY_STRATEGIES_SUCCESS = 'GET_ENTRY_STRATEGIES_SUCCESS';
export const GET_ENTRY_STRATEGIES_ERROR = 'GET_ENTRY_STRATEGIES_ERROR';
